/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY
 */

var module; UMD(module, {
  'minted:m': ['M']
})(this, function (m_module) {
  "use strict";
  var M = m_module.M;

  /**
   * Object for storing community related constants
   */
  M.COMMUNITY = M.COMMUNITY || {};

  /**
   *  Object for storing interruption notification information
   */
  M.COMMUNITY.USER_NOTIFICATION_POPUPS =
    M.COMMUNITY.USER_NOTIFICATION_POPUPS || {};

  M.COMMUNITY.USER_NOTIFICATION_POPUPS.TITLES = {};
  M.COMMUNITY.USER_NOTIFICATION_POPUPS.TITLES['termsAndAgreement'] =
    'please review the terms and conditions for your minted artist store'

  /**
   * Object for storing challenge related constants
   */
  M.COMMUNITY.CHALLENGE = M.COMMUNITY.CHALLENGE || {};

  var stateQueryStringTypes = M.Config['ChallengeConfig'].state_query_string_types;
  /**
   * Object for storing constants related to challenge status
   */
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT = {};

  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.setup.id] = {
      'tileCssClass': stateQueryStringTypes.coming_soon.filter_class,
      'flagCssClass': 'comingSoon',
      'flagText': 'coming soon',
      'bannerActionButtonText': 'submit your artwork',
      'bannerActionButtonDisabled': true,
      'deadlineLabelText': 'submissions open',
      'dashboardPanelActionButtonText': ''
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.submission.id] = {
      'tileCssClass': stateQueryStringTypes.submit.filter_class,
      'flagCssClass': 'openForSubmission',
      'flagText': 'submit',
      'bannerActionButtonText': 'submit your artwork',
      'bannerActionButtonDisabled': false,
      'deadlineLabelText': 'submissions close',
      'dashboardPanelActionButtonText': 'submit'
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.submission_closed.id] = {
      'tileCssClass': stateQueryStringTypes.critique.filter_class,
      'flagCssClass': 'openForCritique',
      'flagText': 'critique',
      'bannerActionButtonText': 'critique',
      'bannerActionButtonDisabled': false,
      'deadlineLabelText': 'voting starts',
      'dashboardPanelActionButtonText': ''
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.nominate.id] = {
      'tileCssClass': stateQueryStringTypes.vote.filter_class,
      'flagCssClass': 'inVoting',
      'flagText': 'vote',
      'bannerActionButtonText': 'vote',
      'bannerActionButtonDisabled': false,
      'deadlineLabelText': 'voting ends',
      'dashboardPanelActionButtonText': 'vote'
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.nominate_select.id] = {
      'tileCssClass': stateQueryStringTypes.voting_closed.filter_class,
      'flagCssClass': 'votingClosed',
      'flagText': '',
      'bannerActionButtonText': 'vote',
      'bannerActionButtonDisabled': true,
      'deadlineLabelText': 'voting starts',
      'dashboardPanelActionButtonText': ''
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.restricted_vote.id] = {
      'tileCssClass': stateQueryStringTypes.restricted_vote.filter_class,
      'flagCssClass': 'votingClosed',
      'flagText': '',
      'bannerActionButtonText': 'vote',
      'bannerActionButtonDisabled': true,
      'deadlineLabelText': 'voting starts',
      'dashboardPanelActionButtonText': 'vote'
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.restricted_vote_closed.id] = {
      'tileCssClass': stateQueryStringTypes.restricted_voting_closed.filter_class,
      'flagCssClass': 'votingClosed',
      'flagText': '',
      'bannerActionButtonText': 'vote',
      'bannerActionButtonDisabled': true,
      'deadlineLabelText': 'voting starts',
      'dashboardPanelActionButtonText': ''
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.vote.id] = {
      'tileCssClass': stateQueryStringTypes.vote.filter_class,
      'flagCssClass': 'inVoting',
      'flagText': 'vote',
      'bannerActionButtonText': 'vote',
      'bannerActionButtonDisabled': false,
      'deadlineLabelText': 'voting ends',
      'dashboardPanelActionButtonText': 'vote'
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.vote_closed.id] = {
      'tileCssClass': stateQueryStringTypes.voting_closed.filter_class,
      'flagCssClass': 'votingClosed',
      'flagText': '',
      'bannerActionButtonText': 'see winners',
      'bannerActionButtonDisabled': true,
      'deadlineLabelText': 'announcing winners soon',
      'dashboardPanelActionButtonText': ''
    };
  M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
    M.Config['ChallengeConfig'].state.published.id] = {
      'tileCssClass':
        stateQueryStringTypes.winners_announced.filter_class,
      'flagCssClass': 'winnersAnnounced',
      'flagText': 'winners',
      'bannerActionButtonText': 'see winners',
      'bannerActionButtonDisabled': false,
      'deadlineLabelText': 'winners announced',
      'dashboardPanelActionButtonText': 'see winners'
    };

  /**
   * Object for storing dropdown option values for filtering
   * challenges by challenge state
   */
  M.COMMUNITY.CHALLENGE.STATE_DROPDOWN_OPTIONS = [
    {
      'option_val': stateQueryStringTypes.all.query_param_val,
      'display_str': 'See All Challenges'
    },
    {
      'option_val': stateQueryStringTypes.submit.query_param_val,
      'display_str': 'Submit artwork'
    },
    {
      'option_val': stateQueryStringTypes.critique_all.query_param_val,
      'display_str': 'Critique'
    },
    {
      'option_val': stateQueryStringTypes.vote.query_param_val,
      'display_str': 'Vote'
    },
    {
      'option_val': stateQueryStringTypes.winners_announced.query_param_val,
      'display_str': 'See Winners'
    },
  ];

  M.COMMUNITY.CHALLENGE.PANEL_ID = {
    'about_challenge_panel': '#aboutChallengePanel',
    'feedback_and_polls_panel': '#feedbackAndPollsPanel',
    'submissions_panel': '#designSubmissionsPanel',
    'winners_panel': '#winnersPanel',
    'special_prize_winners_panel': '#specialPrizeWinnersPanel'
  };

  /**
   * Object for storing Activity Feed-related constants
   */
  M.COMMUNITY.ACTIVITY_FEED = M.COMMUNITY.ACTIVITY_FEED || {};

  /**
   * Activity type constants for the Activity Feed Panel
   */
  M.COMMUNITY.ACTIVITY_FEED.TYPE_DICT = {};

  M.COMMUNITY.ACTIVITY_FEED.TYPE_DICT[
    M.Config['EventConfig'].type.submit_design.id] = {
      'activityClass': 'submissionActivity',
      'description': 'submitted this artwork',
      'imgClass': 'submissionIconGrey'
    };
  M.COMMUNITY.ACTIVITY_FEED.TYPE_DICT[
    M.Config['EventConfig'].type.comment_on_design.id] = {
      'activityClass': 'commentActivity',
      'description': 'commented on this artwork',
      'calloutLinkText': 'see more',
      'imgClass': 'commentIconGrey'
    };
  M.COMMUNITY.ACTIVITY_FEED.TYPE_DICT[
    M.Config['EventConfig'].type.poll_design.id] = {
      'activityClass': 'pollActivity',
      'description': 'created a poll',
      'calloutLinkText': 'take poll',
      'imgClass': 'pollIconGrey'
    };
  M.COMMUNITY.ACTIVITY_FEED.TYPE_DICT[
    M.Config['EventConfig'].type.like_design.id] = {
      'activityClass': 'likeActivity',
      'description': 'liked this artwork',
      'imgClass': 'likeIconGrey'
    };
  M.COMMUNITY.ACTIVITY_FEED.TYPE_DICT[
    M.Config['EventConfig'].type.request_feedback_design.id] = {
      'activityClass': 'feedbackActivity',
      'description': 'requested feedback',
      'calloutLinkText': 'give feedback',
      'imgClass': 'feedbackIconGrey'
    };

  return {};
});
